import { Attribute, AttributeConstraintEnumAllOf, AttributeProfile } from '@isdd/metais-common/api/generated/types-repo-swagger'
import { DISPLAY_AS } from '@isdd/metais-common/constants'

// when displayAs is set to 'raw', the value is shown as it comes from BE, so there is no need to fetch the enum from BE
export const calculateConstraintFromAttributes = (entityAttributes: Attribute[] | undefined) => {
    return (
        entityAttributes
            ?.filter((attribute) => attribute?.displayAs !== DISPLAY_AS.RAW)
            ?.map((attribute: Attribute) =>
                attribute?.constraints
                    ?.filter((item) => item.type === 'enum')
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    .map((constraint: AttributeConstraintEnumAllOf) => constraint?.enumCode),
            )
            .flat() ?? []
    )
}

export const calculateConstraintFromAttributeProfiles = (entityAttributeProfiles: AttributeProfile[] | undefined, onlyValidAttributes = false) => {
    return (
        entityAttributeProfiles
            ?.map((profile: AttributeProfile) =>
                profile?.attributes
                    ?.filter((a) => (onlyValidAttributes === true ? a.valid === true : true) && a?.displayAs !== DISPLAY_AS.RAW)
                    .map((attribute) =>
                        attribute?.constraints
                            ?.filter((item) => item.type === 'enum')
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            //@ts-ignore
                            .map((constraint: AttributeConstraintEnumAllOf) => constraint?.enumCode),
                    ),
            )
            .flat(2) ?? []
    )
}
